export default __webpack_public_path__ + "static/media/gallery-wip-pommel_00.5db8da98.jpg";